<template>
  <div v-if="this.$route.name !== 'InvoiceViewer'">

    <beta-header v-if="showBetaHeader" @closeBeta="closeBeta()" />

    <header v-if="this.$route.name === 'Checkout' || this.$route.name === 'Review'" class="site_header checkout_header"
      :class="{ 'beta-chk-header': showBetaHeader }">
      <div class="logo_box">
        <div class="flex_col">
          <router-link class="chk-logo-wrapper" :to="{ name: 'Home' }">
            <img src="img/logo_icon.svg" alt="logo_icon" class="logo_icon">
            <img src="img/logo_txt.svg" alt="logo_txt" class="full_logo">
          </router-link>
          <p class="logo-txt">Powered by Eichlers of Boro Park</p>
        </div>
      </div>
    </header>


    <!-- mobile header -->
    <header v-if="this.$route.name !== 'Checkout'
      && this.$route.name !== 'Review'
      && isMobile" class="only-mobile" :class="{ 'beta-chk-header': showBetaHeader }">
      <mobile-header />
    </header>

    <!-- mobile actions -->
    <mobile-action-top />

    <header v-if="this.$route.name != 'Checkout'
      && this.$route.name != 'Review'" id="header" class="site_header sticky_header no-mobile"
      :class="{ 'beta-sticky_header': showBetaHeader }">
      <div class="header_left">
        <div class="nav_icon" @click="toggleDepartmets()">
          <img src="/img/nav_menu.svg" alt="menu_icon" class="img_contain">
        </div>
        <div class="mob_search_icon">
          <img src="/img/search_icon_thin.svg" alt="search_icon">
        </div>
        <div class="logo_box">
          <div class="flex_col">
            <router-link :to="{ name: 'Home' }" class="logo_box_link">
              <img src="/img/logo_icon.svg" alt="logo_icon" class="logo_icon">
              <img src="/img/logo_txt.svg" alt="txt_icon" class="full_logo">
            </router-link>
            <p class="logo-txt">Powered by Eichlers of Boro Park</p>
          </div>
        </div>
      </div>

      <div v-if="!showSearchInput" id="search" class="search_container head_action_anchor" @click="clickSearch()">
        <img src="/img/search_icon.svg" alt="search_icon" class="search_icon">
        <p class="search_txt">Search</p>
      </div>

      <search v-on:showOverlay="openOverlay()" @inputOpen="inputOpened()" @inputClosed="inputClosed()" ref="search" />

      <div class="header_right">
        <div @click="toggleAccount()" class="header_account_wrap head_action_anchor hover">
          <p id="account" v-if="_isAuth">{{ customerFirstName || "Account" }}</p>
          <p id="account" v-else>Account</p>
        </div>

        <div id="account" v-if="showAccount" class="hdd_clickable_wrapper account_header_list fadeIn animated faster"
          v-on-clickaway="switchFromAccount">
          <div v-if="!_isAuth" @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="{ name: 'Login' }">Login</router-link>
          </div>
          <div @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="{ name: 'Account' }">My Account</router-link>
          </div>
          <div @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="{ name: 'Orders' }">My Orders</router-link>
          </div>
          <div @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="_isAuth ? { name: 'Favorites' } : { name: 'GuestFavorites' }">My
              Favorites</router-link>
          </div>
          <div @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="{ name: 'BueAgain' }">Buy it Again</router-link>
          </div>
          <div @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="{ name: 'DigitalLibary' }">Digital Libary</router-link>
          </div>
          <div @click="closeOverlay()" class="ahl_single">
            <router-link class="ahl_link" :to="{ name: 'Subscriptions' }">Subscriptions</router-link>
          </div>
          <div @click="closeOverlay()" v-if="_isAuth" class="ahl_single">
            <p class="ahl_link" @click="signOut()">Sign Out</p>
          </div>
        </div>


        <div @click="toggleAssis()" class="header_support_wrap head_action_anchor">
          <p id="assistance">Assistance</p>
        </div>
        <div class="header_cart_wrap">
          <bag-icon />
        </div>
      </div>
      <div class="breadcrumbs_wrapper" :class="{ 'no-background': backgroundColor }">
        <div class="boxed_width">
          <product-breadcrumbs v-if="this.$route.name === 'ProductsShow'
            || this.$route.name === 'ProductsIndex'
            || this.$route.name === 'SearchIndex'
            || this.$route.name === 'eGift'
            || this.$route.name === 'SelectSchool'
            || this.$route.name === 'SelectGrade'
            || this.$route.name === 'SelectItems'" />
          <div class="abs_ship" v-if="freeShipping != undefined">
            <div class="abs_ship_inner">
              <div>
                <p class="abss_txt">ShopEichlers.com</p>
              </div>
              <div v-if="freeShipping" class="shipping-wrap" @click="shippingTerms()">
                <p class="abss_txt abss_sep">|</p>
                <p class="abss_txt">Free Shipping over {{ '$' + freeShipping }}</p>
                <span class="arrow-shipping"></span>
              </div>
              <div v-else class="shipping-wrap" @click="shippingTerms()">
                <p class="abss_txt abss_sep">|</p>
                <p class="abss_txt">Free Shipping on all orders</p>
                <span class="arrow-shipping"></span>
              </div>
              <shipping-terms ref="shippingTerms" />
            </div>
          </div>
          <product-language-option v-if="this.$route.name === 'ProductsShow'
            || this.$route.name === 'ProductsIndex'
            || this.$route.name === 'SearchIndex'" />
        </div>
      </div>


      <div id="assistance" v-if="showAssis" class="hdd_clickable_wrapper hdd_shipping fadeIn animated faster"
        v-on-clickaway="switchFromAssis">
        <p class="hdds_txt">{{ customerFirstName || 'Hi there' }}, we’re available to<br> assist you!</p>

        <!-- <a href="tel:800-433-3345" class="hdds_number">800.342.4537</a>
        <p class="hdds_txt">or email us at:</p> -->

        <p @click="chat()" class="hdds_number chat">Chat with us</p>
        <p class="hdds_txt">or email us at:</p>


        <a href="mailto:help@ShopEichlers.com" class="hdds_email">help@ShopEichlers.com</a>
      </div>
      <transition enter-active-class="fadeIn animated faster" leave-active-class="fadeOut animated faster">
        <div :class="hddOverlayClass" v-if="showOverlay" @click="closeOverlay()"></div>
      </transition>

    </header>

    <div v-if="this.$route.name !== 'Checkout' && this.$route.name !== 'Review'" class="sticky_header_space no-mobile"
      :class="[
        { 'beta-sticky_header_space': showBetaHeader && !header_space },
        headerSpaceClass,]">
    </div>
    <categories-list v-if="!isMobile" ref="categories-list"></categories-list>
  </div>
</template>

<script>
// import CustomKeyboard from "../keyboard/CustomKeyboard";
import { mapGetters, mapActions } from "vuex";
import { mixin as clickAway } from "vue-clickaway";
import HeaderAnimations from './headerAnimation.js'
import BetaHeader from './BetaHeader'
import MobileHeader from './MobileHeader'
import MobileActionTop from './MobileActionTop'
import Search from './Search'
import ProductLanguageOption from '../products/components/ProductLanguageOption'
import CategoriesList from '../categories/CategoriesList'
import ProductBreadcrumbs from '../products/components/ProductBreadcrumbs'
import ShippingTerms from '../partials/ShippingTerms'
import BagIcon from '../bag/BagIcon'

let unwatcher;
export default {
  mixins: [clickAway],
  data() {
    return {
      showOverlay: false,
      searchInput: "",
      showAccount: false,
      showAssis: false,
      showSearchInput: false,
      isClosing: false,
      showBetaHeader: true,
      isMobile: false,
      queryMediaIns: {},
      headerAnimation: {}
    };
  },
  computed: {
    ...mapGetters({
      _isAuth: "customer/isAuth",
      customer: "customer/getCustomer",
      customerFirstName: "customer/getFirstName",
      freeShipping: 'shippingRates/freeShipping',
    }),
    backgroundColor() {
      return (this.$route.name !== 'ProductsShow') &&
        (this.$route.name !== 'ProductsIndex') &&
        (this.$route.name !== 'SearchIndex') &&
        (this.$route.name !== 'eGift') &&
        (this.$route.name !== 'SelectSchool') &&
        (this.$route.name !== 'SelectGrade') &&
        (this.$route.name !== 'SelectItems');
    },
    header_space() {
      return this.$route.name !== 'ProductsShow'
        && this.$route.name !== 'ProductsIndex'
        && this.$route.name !== 'SearchIndex'
    },
    hddOverlayClass() {
      return this.showBetaHeader ? 'hdd_overlay beta_hdd_overlay' : 'hdd_overlay'
    },
    headerSpaceClass() {
      if (this.showBetaHeader && this.header_space) {
        return 'beta-header-space'
      }
      if (!this.showBetaHeader && this.header_space) {
        return 'header_space'
      }
    }
  },
  methods: {
    ...mapActions({ _logout: 'customer/logout' }),
    signOut() {
      this.$root.$refs["spinner"].startSpinner();
      this._logout().then(() => {
        this.$root.$refs["spinner"].stopSpinner()
        this.$router.push({ name: 'Home' }).catch(err => { });
      }).catch(err => {
        this.$root.$refs.spinner.stopSpinner()
        handleError(err, this.$router)
      })
    },
    switchFromAssis($event) {
      let targetId = event.target.id;
      let offsetParentId = _.get(event.target.offsetParent, 'id');
      if (offsetParentId != undefined) {
        let ParentId = event.target.offsetParent.id;
        if (ParentId !== "searchBox" && targetId !== "search" && targetId !== "account") {
          this.closeOverlay();
        } else { this.showAssis = false; }
      }
      else {
        if (targetId !== "search" && targetId !== "account") {
          this.closeOverlay();
        } else { this.showAssis = false; }
      }
    },
    switchFromAccount($event) {
      let targetId = event.target.id;
      let offsetParentId = _.get(event.target.offsetParent, 'id');
      if (offsetParentId != undefined) {
        let ParentId = event.target.offsetParent.id;
        if (ParentId !== "searchBox" && targetId !== "search" && targetId !== "assistance") {
          this.closeOverlay();
        } else { this.showAccount = false; }
      }
      else {
        if (targetId !== "search" && targetId !== "assistance") {
          this.closeOverlay();
        } else { this.showAccount = false; }
      }
    },
    toggleAssis() {
      if (this.showOverlay == true && !this.showAssis) {
        this.showAssis = true;
      }
      else {
        if (!this.showAssis) {
          this.openOverlay();
          this.showAssis = true;
        }
        else {
          this.closeOverlay()
        }
      }
    },
    toggleAccount() {
      //if(!this.isClosing){
      if (this.showOverlay == true && !this.showAccount) {
        this.showAccount = true;
      }
      else {
        if (!this.showAccount) {
          this.openOverlay();
          this.showAccount = true;
        }
        else {
          this.closeOverlay()
        }
      }
      //}
    },
    toggleDepartmets() {
      this.$refs["categories-list"].toggleVisibility();
    },
    openOverlay() {
      document.body.classList.add("no_scroll");
      this.showOverlay = true;
    },
    closeOverlay() {
      document.body.classList.remove("no_scroll");
      this.$refs.search.showKeyboard = false;
      this.showAccount = false;
      this.showAssis = false;
      if (this.searchInput) {
        this.showOverlay = false;
        this.$refs.search.showSearchInput = true,
          this.$refs.search.showSearchSuggest = false
      } else {
        this.showOverlay = false;
        this.$refs.search.hideShowSearchSuggest()
      }
    },
    clickSearch() {
      this.openOverlay();
      this.$refs.search.displayShowSearchSuggest();
    },
    inputOpened() {
      this.showSearchInput = true;
    },
    inputClosed() {
      this.showSearchInput = false;
    },
    shippingTerms() {
      this.$refs.shippingTerms.open()
    },
    closeBeta() {
      this.showBetaHeader = false;
      localStorage.setItem('beta', 'false')
    },
    detectQueryChange(e) {
      this.isMobile = !e.matches
    },
    chat() {
      Beacon('open')
    },
  },

  created() {
    // let beta = localStorage.getItem('beta')
    // this.showBetaHeader = beta ? false : true 
  },

  mounted() {
    this.headerAnimation = new HeaderAnimations(this.showBetaHeader)

    if (this.$refs.search) {
      unwatcher = this.$watch(() => {
        return this.$refs.search.searchInput;
      }, (val) => {
        if (val) { this.searchInput = val }
        else { this.searchInput = "" }
      });
    };
    this.queryMediaIns = window.matchMedia('(min-width: 769px)')
    this.isMobile = !this.queryMediaIns.matches
    this.queryMediaIns.addListener(this.detectQueryChange)
  },
  watch: {
    $route(oldVal, newVal) {
      if (oldVal.path !== newVal.path) {
        let header = document.getElementById('header')
        if (header) {
          header.classList.add('nav-down')
          header.classList.remove('nav-up', 'beta-nav-up')
        }
      }

    },
    showBetaHeader() {
      this.headerAnimation.clearInterval()
      this.headerAnimation = new HeaderAnimations(this.showBetaHeader)
    }
  },
  components: {
    BetaHeader,
    MobileHeader,
    MobileActionTop,
    Search,
    ProductLanguageOption,
    CategoriesList,
    ProductBreadcrumbs,
    ShippingTerms,
    BagIcon
  }
};
</script>
<style scoped>
.faster {
  animation-duration: 250ms;
}

.ahl_link:last-child:hover {
  cursor: pointer;
}

.no-background {
  background-color: transparent !important;
}

.header_space {
  height: 100px !important;
}

.shipping-wrap {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.arrow-shipping {
  height: 10px;
  width: 10px;
  margin-left: 5px;
  background-image: url(/img/arrow_shipping.svg);
  background-repeat: no-repeat;
  background-position: center;
}

.chk-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat {
  cursor: pointer;
}


/* for beta header */
.beta-sticky_header {
  top: 39px;
}

.beta-sticky_header_space {
  height: 189px;
}

.beta-header-space {
  height: 139px;
}

.beta-chk-header {
  margin-top: 39px;
}

.beta_hdd_overlay {
  top: 138px !important;
}

@media screen and (max-width: 959px) {
  .arrow-shipping {
    background-image: url(/img/arrow_shipping_black.svg);
  }

  .header_space {
    height: 89px !important;
  }

  .beta-sticky_header_space {
    height: 132px;
  }

  .beta-header-space {
    height: 128px !important;
  }

  .beta_hdd_overlay {
    top: 132px !important;
  }

  .chk-logo-wrapper {
    width: 150px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/layouts/LayoutsHeader.vue